import { clsx } from 'clsx';
import { t } from '../../i18n';
import { ChevronIcon } from '../icons';
import styles from './ui.module.css';

/**
 * Возврат обведённым квадратом — так он нарисован во всех макетах.
 *
 * Вкуишный `PanelHeaderBack` — это голая стрелка с подписью и без рамки. Она
 * не спорила бы ни с чем, будь она одна, но на экранах с кадром возврат лежит
 * поверх фотографии обведённым квадратом, и два разных возврата в одном
 * приложении — это ровно то расхождение, которое видно сразу.
 *
 * `overlay` — вариант поверх кадра: там рамка светлая и под ней заливка,
 * иначе стрелка пропадает на светлом снимке.
 */
export function BackButton({
  onClick,
  overlay = false,
}: {
  onClick: () => void;
  overlay?: boolean;
}) {
  return (
    <button
      type="button"
      className={clsx(styles.backButton, overlay && styles.backButtonOverlay)}
      aria-label={t('ui.back')}
      onClick={onClick}
    >
      <ChevronIcon direction="left" />
    </button>
  );
}
